import { PayAmLogo } from '@approvalmax/ui';
import { useMemo } from 'react';
import bemFactory from 'react-bem-factory';
import { DomainEntitiesCompanyRole } from 'shared/data/webApp/v2';
import { getPath, Path } from 'urlBuilder';

import { useGetCompany, useGetCompanyMe } from '../../Drawer.hooks';
import { messages } from './PayMenu.messages';

const qa = bemFactory.qa('payDropdown');

export const usePayLinkItems = (companyId: string) => {
    const { data: me } = useGetCompanyMe(companyId);
    const { data: company } = useGetCompany(companyId);

    const isAdvancedUser =
        !!me?.role &&
        [
            DomainEntitiesCompanyRole.Auditor,
            DomainEntitiesCompanyRole.Manager,
            DomainEntitiesCompanyRole.WorkflowManager,
        ].includes(me.role);

    return useMemo(
        () =>
            company?.id
                ? [
                      {
                          id: 'pay',
                          name: messages.payMenu,
                          startIcon: PayAmLogo,
                          dataQa: qa(),
                          subItems: [
                              {
                                  id: Path.wallets,
                                  name: messages.wallets,
                                  available: isAdvancedUser,
                                  to: getPath(Path.wallets, company.id),
                                  dataQa: qa('navigationItem'),
                                  dataQaName: 'wallets',
                              },
                          ],
                      },
                  ]
                : [],
        [company?.id, isAdvancedUser]
    );
};
